// ============================================
// Home Module - Index (ES6 Entry Point)
// ============================================

// Content loading & rendering
import {
  switchHomeCategory,
  loadHomeContent,
  setupInfiniteScroll,
  renderHomeGrid,
  renderHomeCard
} from './content.js';

// Search Modal
import {
  openSearchModal,
  closeSearchModal,
  handleSearch
} from './search.js';

// Content Detail Modal
import {
  showContentDetail,
  updateLikeButtonState,
  updateDetailActionButtons,
  toggleContentLike,
  closeContentDetailModal,
  initDetailScrollHandler,
  showDetailMenu,
  closeDetailMenu,
  editMyCreation,
  shareContent,
  reportContent,
  blockCreator,
  startNewChat,
  continueRoom,
  showAllContent
} from './detail.js';

// Event handlers (onclick 대체)
import { initHomeEvents } from './events.js';

// ============================================
// 초기화
// ============================================

function init() {
  console.log('[HomeModule] ES6 모듈 초기화');
}

// ============================================
// 모듈 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// ============================================
// Public API
// ============================================

const HomeModule = {
  // 콘텐츠 로딩
  switchHomeCategory,
  loadHomeContent,
  setupInfiniteScroll,
  // 렌더링
  renderHomeGrid,
  renderHomeCard,
  // 검색
  openSearchModal,
  closeSearchModal,
  handleSearch,
  // 상세 모달
  showContentDetail,
  updateLikeButtonState,
  updateDetailActionButtons,
  toggleContentLike,
  closeContentDetailModal,
  initDetailScrollHandler,
  showDetailMenu,
  closeDetailMenu,
  editMyCreation,
  shareContent,
  reportContent,
  blockCreator,
  startNewChat,
  continueRoom,
  showAllContent
};

// 전역 노출 (기존 코드 호환성)
window.HomeModule = HomeModule;

// 동적 HTML onclick에서 직접 호출되는 함수들
window.showContentDetail = showContentDetail;
window.closeContentDetailModal = closeContentDetailModal;
window.renderHomeCard = renderHomeCard;
window.loadHomeContent = loadHomeContent;
window.switchHomeCategory = switchHomeCategory;
window.setupInfiniteScroll = setupInfiniteScroll;

export default HomeModule;
